import { render, staticRenderFns } from "./StatisticsPackerStats.vue?vue&type=template&id=03eea764&scoped=true&"
import script from "./StatisticsPackerStats.vue?vue&type=script&lang=js&"
export * from "./StatisticsPackerStats.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsPackerStats.vue?vue&type=style&index=0&id=03eea764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eea764",
  null
  
)

export default component.exports